import { render, staticRenderFns } from "./CrisiImpresa.vue?vue&type=template&id=01b0e562&"
import script from "./CrisiImpresa.vue?vue&type=script&lang=js&"
export * from "./CrisiImpresa.vue?vue&type=script&lang=js&"
import style0 from "./CrisiImpresa.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports